export enum ActionTypes {
  LOGGING_IN = 'LOGGING_IN',
  LOGGED_IN = 'LOGGED_IN',
  LOGGED_IN_CLEAR = 'LOGGED_IN_CLEAR',
  LOGGED_ERROR = 'LOGGED_ERROR',
  LOGOUT = 'LOGOUT'
}
